import { TemplateTransportType } from "../../types/communication/transport-type"

export interface TreatmentPlanModel {
  id: number
  description: string
  dateCreated: Date
  status: TreatmentPlanStatus
  isAutoFollowUp: boolean
  autoFollowUpStatus: AutoFollowUpStatus
  isAutomaticCommunicationActive: boolean
  treatmentPlanItems: TreatmentPlanItemModel[]
}

export interface UpdateTreatmentPlanModel {
  isAutoFollowUp: boolean
}

export interface TreatmentPlanItemModel {
  id: number
  tooth: string
  description: string
  code: string
  totalCost: number
  insuranceEst: number
  patientCost: number
  appointmentDate?: Date
  incudeFollowUp: boolean
}

export interface SecureAttachment {
  fileName: string
  displayName: string
  description: string
  dateCreated: Date
  addedByCustomerUserId: number
  addedByFullName: string
}

export interface UpdateTreatmentPlanItemModel {
  incudeFollowUp: boolean
}

export type TreatmentPlanStatus = 'Proposed' | 'Referred' | 'Accepted' | 'Rejected'
  | 'Completed' | 'Other' | 'Deleted' | 'Scheduled';

export type AutoFollowUpStatus = 'On' | 'Off' | 'Disabled' | 'OutOfRange';

export interface PatientNote {
  id: number
  userId: number
  note: string
  date: Date
  authorId?: number
  authorFullName?: string
}

export interface PatientFeedback {
  idPatientFeedback: number
  date: Date
  message: string
  ratingScore: number
  feedbackType: FeedbackType
}

export type FeedbackType = 'Review' | 'Survey';

export enum CommStatus {
  AwaitingSending = 0,
  Delivered = 1,
  Read = 2,
  Responded = 3,
  Busy = 4,
  NoAnswer = 5,
  BadNumber = 6,
  Send = 7,
  Error = 8,
  BlockedBySpamProtector = 9,
  SendNow = 10,
  Dropped = 11,
  Bounce = 12,
  SpamReport = 13,
  NotActual = 14,
  MultipleAppointments = 15,
  Confirmed = 16,
  AskedForCallback = 17,
  CheckPhoneNumber = 18,
  LeftMessage = 19,
  CheckCallerId = 20,
  SmsTooLong = 21,
  IncomprehensibleAnswer = 22,
  WebhookProcessError = 23,
  LetterTooLong = 24,
  Scheduled = 30,
  ScheduledAwaitingConfirmation = 31,
  ReceivedAnswer = 44,
  RecoverableError = 100,
  CancelledDueToInactivePractice = 111,
  CancelledBySettings = 112,
  Expired = 115,
  InProcess = 254
}

export interface InboxCommunicationFilterRequest {
  phoneNumbers: string[]
  patientId?: number
  transportType?: TemplateTransportType
  startDate?: Date
  pageSize?: number
}


export interface PatientConnect365Enrollment {
  alreadyEnrolled: boolean
  isReadyToSendEnrollment: boolean
  validEmailAddress: boolean
  isEnrollAvailable: boolean
  inactiveUser: boolean
}

